import { Card, Col, Row, Statistic, Tooltip } from 'antd';
import { ReactNode } from 'react';

export interface StatisticCardItem {
  key: string;
  title: ReactNode;
  value: number | string;
  icon?: ReactNode;
  tooltip?: ReactNode;
}

interface StatisticsCardsProps {
  items: StatisticCardItem[];
}

const StatisticsCards = ({ items }: StatisticsCardsProps) => {
  if (items.length === 0) {
    return null;
  }

  const span = items.length > 0 ? Math.floor(24 / items.length) : 24;

  return (
    <Row gutter={16} style={{ paddingInline: 24 }}>
      {items.map((item) => {
        return (
          <Col span={span} key={item.key}>
            <Tooltip title={item.tooltip ?? undefined}>
              <Card>
                <Statistic title={item.title} value={item.value} prefix={item.icon} />
              </Card>
            </Tooltip>
          </Col>
        );
      })}
    </Row>
  );
};

export default StatisticsCards;
